export const decoder = new TextDecoder;

export const encoder = new TextEncoder;
